'use strict';

var novicell = novicell || {};
novicell.mobileFooter = novicell.mobileFooter || function () {
    function init() {
        var newsTrigger = document.querySelector('#js-mobile-news-trigger');
        var linkListTrigger = document.querySelector('#js-mobile-link-list-trigger');
        var socialMediaTrigger = document.querySelector('#js-mobile-social-media-list-trigger');
        var news = document.querySelector('#js-mobile-news');
        var linkList = document.querySelector('#js-mobile-link-list');
        var socialMediaList = document.querySelector('#js-mobile-social-media-list');

        if(newsTrigger != null) {
            newsTrigger.addEventListener('click', function () {
                news.classList.toggle('show-footer-content');
                newsTrigger.classList.toggle('turn-arrow');
            }, true);  
        }

        if(linkListTrigger != null) {
            linkListTrigger.addEventListener('click', function () {
                linkList.classList.toggle('show-footer-content');
                linkListTrigger.classList.toggle('turn-arrow');
            }, true);  
        }

        if(socialMediaTrigger != null) {
            socialMediaTrigger.addEventListener('click', function () {
                socialMediaList.classList.toggle('show-footer-content');
                socialMediaTrigger.classList.toggle('turn-arrow');
            }, true);  
        }

    }
    return {
        init:init
    };
}();
